import { Box, Card as MuiCard, CardContent, CardHeader, IconButton } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'

type CardProps = {
  children: React.ReactNode
  avatar?: React.ReactNode
  title?: string
  height?: number
  onEditClick?: () => void
}

export const CardsListContainer = ({ children }: { children: React.ReactNode }) => (
  <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap' }}>{children}</Box>
)

export const CardContainer = ({ children }: { children: React.ReactNode }) => <Box sx={{ width: 349 }}>{children}</Box>

export const Card = ({ children, avatar, height, title, onEditClick }: CardProps) => (
  <MuiCard sx={{ height }}>
    <CardHeader
      avatar={avatar}
      action={
        <IconButton onClick={onEditClick}>
          <EditIcon />
        </IconButton>
      }
      title={title}
    />
    <CardContent style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: '16px' }}>{children}</CardContent>
  </MuiCard>
)
